import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BiArrowBack } from "react-icons/bi";
import { useGetCountryByAlpha3Code } from "../services/countries";
import Loader from "../components/Loader";

const Details = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [country, setCountry] = useState(state?.data || null);

  useEffect(() => {
    if (!country) {
      navigate("/");
    }
  }, [country, navigate]);

  const { isLoading: isBorderLoading, data: borders } =
    useGetCountryByAlpha3Code(country?.borders);

  if (!country) return null;

  const {
    name,
    flags,
    population,
    capital,
    subregion,
    nativeName,
    topLevelDomain,
    currencies,
    languages,
  } = country;

  return (
    <section className="min-h-screen bg-[var(--body-light-color)] dark:bg-[var(--body-dark-color)] dark:text-white px-4 sm:px-6 lg:px-10 xl:px-16 2xl:px-20 py-8 pt-[90px] transition-colors duration-300">
      <div className="max-w-[1440px] mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-white dark:bg-containerColor dark:text-white shadow-md hover:shadow-lg transition-all duration-300"
        >
          <BiArrowBack className="text-lg" />
          <span className="font-medium">Back</span>
        </button>

        <div className="pt-10 lg:pt-16">
          <article className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 xl:gap-24 items-center">
            <div className="w-full">
              <img
                src={flags?.png}
                alt={`${name} flag`}
                className="w-full h-[240px] sm:h-[320px] lg:h-[400px] object-cover rounded-2xl shadow-lg"
              />
            </div>

            <div className="flex flex-col gap-8">
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold">
                {name}
              </h1>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-3 text-sm sm:text-base">
                  <p>
                    <span className="font-semibold">Native Name: </span>
                    <span className="font-light">{nativeName || "N/A"}</span>
                  </p>

                  <p>
                    <span className="font-semibold">Population: </span>
                    <span className="font-light">
                      {population?.toLocaleString() || "N/A"}
                    </span>
                  </p>

                  <p>
                    <span className="font-semibold">Sub Region: </span>
                    <span className="font-light">{subregion || "N/A"}</span>
                  </p>

                  <p>
                    <span className="font-semibold">Capital: </span>
                    <span className="font-light">{capital || "N/A"}</span>
                  </p>
                </div>

                <div className="space-y-3 text-sm sm:text-base">
                  <p>
                    <span className="font-semibold">Top Level Domain: </span>
                    <span className="font-light">
                      {topLevelDomain?.[0] || "N/A"}
                    </span>
                  </p>

                  <p>
                    <span className="font-semibold">Currencies: </span>
                    <span className="font-light">
                      {currencies?.[0]?.code || currencies?.[0]?.name || "N/A"}
                    </span>
                  </p>

                  <p>
                    <span className="font-semibold">Languages: </span>
                    <span className="font-light">
                      {languages?.map((lang) => lang.name).join(", ") || "N/A"}
                    </span>
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-lg font-semibold mb-4">
                  Border Countries{!borders?.length ? ": None" : ":"}
                </h2>

                {isBorderLoading ? (
                  <Loader />
                ) : (
                  <div className="flex flex-wrap gap-3">
                    {borders?.map((border) => (
                      <button
                        key={border.alpha3Code || border.name}
                        onClick={() => setCountry(border)}
                        className="px-4 py-2 rounded-lg bg-white dark:bg-containerColor shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 text-sm"
                      >
                        {border.name}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Details;
